import { useCallback, useMemo } from 'react';

import { CopyToClipboardButton, LinkIcon, TextLink, TextLinkProps } from '../../index';

export interface TableLinkProps extends TextLinkProps {
  label?: string;
  url: string;
  icon?: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
  absoluteURL?: boolean;
  truncate?: boolean;
  showCopyLink?: boolean;
}

const containerClass = 'cursor-pointer outline-black flex flex-nowrap items-center group min-w-0';
const linkWrapperBase = 'relative shrink overflow-hidden';
const iconClass = 'h-4 w-4 mr-1 shrink-0';

export const relativeToAbsoluteUrl = (relativeURL: string) => {
  const link = document.createElement('a');
  link.href = relativeURL;
  return link.href;
};

export const TableLink = (props: TableLinkProps) => {
  const { label, url, icon, absoluteURL = true, truncate = true, showCopyLink = true, ...rest } = props;

  const copyURL = useMemo(() => (absoluteURL ? relativeToAbsoluteUrl(url) : url), [url, absoluteURL]);
  const onClick = useCallback(
    (event: React.KeyboardEvent<HTMLElement>) => {
      if (event.key === 'Enter' || event.key === ' ') {
        window.location.href = url;
      }
    },
    [url]
  );

  const linkWrapperStyle = truncate ? linkWrapperBase + ' truncate' : linkWrapperBase;

  return (
    <div data-testid="table-link-container" className={containerClass} tabIndex={0} onKeyDown={onClick}>
      {!!icon && icon({ className: iconClass, title: 'LinkIcon' })}
      <span className={linkWrapperStyle}>
        <TextLink href={url} tabIndex={-1} target="_blank" rel="noreferrer" {...rest}>
          {label}
        </TextLink>
      </span>
      {showCopyLink && <CopyToClipboardButton textToCopy={copyURL} tooltipText="Copy link" copyIcon={LinkIcon} />}
    </div>
  );
};
export default TableLink;
